var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "flex relative items-start flex-col w-full",
      class: _vm.ckickableClass,
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-row justify-between w-full" },
        [
          _c(
            "div",
            { staticClass: "flex flex-row" },
            [
              _c(
                "div",
                {
                  staticClass: "flex-shrink-0",
                  class: _vm.avatarOnly ? "tooltip" : "",
                },
                [
                  _vm.image
                    ? [
                        _vm._t(
                          "image",
                          function () {
                            return [
                              _c("S3Image", {
                                class: [
                                  _vm.defaultImageClasses,
                                  _vm.avatarStyleClasses,
                                ],
                                attrs: { s3FileKey: _vm.image },
                              }),
                            ]
                          },
                          {
                            defaultClasses: [
                              _vm.defaultImageClasses,
                              _vm.avatarStyleClasses,
                            ],
                            image: _vm.image,
                          }
                        ),
                      ]
                    : [
                        _vm._t(
                          "initial",
                          function () {
                            return [
                              _c(
                                "span",
                                {
                                  class: [
                                    _vm.defaultInitialsClasses,
                                    _vm.avatarStyleClasses,
                                  ],
                                  style: _vm.bgStyle,
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-sm leading-none text-white",
                                    },
                                    [_vm._v(_vm._s(_vm.initial) + " ")]
                                  ),
                                ]
                              ),
                            ]
                          },
                          {
                            defaultClasses: [
                              _vm.defaultInitialsClasses,
                              _vm.avatarStyleClasses,
                            ],
                          }
                        ),
                      ],
                  _vm.avatarOnly
                    ? [
                        _c(
                          "span",
                          {
                            staticClass: "tooltiptext ml-2",
                            style: `background-color: ${_vm.initialColor}`,
                          },
                          [_vm._v(_vm._s(_vm.title))]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openDate,
                                expression: "openDate",
                              },
                            ],
                            staticClass:
                              "text-xs font-thin leading-5 text-gray-400",
                          },
                          [_vm._v(" " + _vm._s(_vm.openDate) + " ")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              [
                _c("div", { staticClass: "flex flex-col shrink-0" }, [
                  _c(
                    "div",
                    { staticClass: "w-1/8 shrink-0 witdh-fix wrap ml-2" },
                    [
                      !_vm.avatarOnly
                        ? _c("div", [
                            _vm.firstNames.length > 15
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "shrink-0 text-xl font-semibold",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.firstNames.substring(0, 15) +
                                            "..."
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(" " + _vm._s(_vm.lastNames)),
                                  ]
                                )
                              : _c("span", { staticClass: "customFont" }, [
                                  _vm._v(
                                    _vm._s(_vm.firstNames) +
                                      "  " +
                                      _vm._s(_vm.lastNames)
                                  ),
                                ]),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.openDate,
                                    expression: "openDate",
                                  },
                                ],
                                staticClass:
                                  "text-sm font-normal text-gray-new",
                              },
                              [_vm._v(" " + _vm._s(_vm.openDate) + " ")]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ],
            ],
            2
          ),
          _vm._t("notesAction"),
        ],
        2
      ),
      _c("div", { staticClass: "font-normal shrink-0 pt-1" }, [
        _c("span", { staticClass: "shrink-0" }, [
          _c("p", [_vm._v(" " + _vm._s(_vm.notes))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }